<template>
  <div>
    <!-- 树谱数据 -->

    <div id="main" ref="imageWrapper" v-if="is_ONE == '1'">
      <div class="wrapper" ref="wrapper">
        <div id="content" class="content">
          <tree-charts :dataSource="mianDic" :isRoot="isR"></tree-charts>
        </div>
      </div>
    </div>

    <div></div>

    <div class="missing-view" v-if="is_ONE == '2'">
      <img src="../assets/img/home.png" style="width: 400px; height: 500px" />
      <div class="missing-but" @click="didAddNew()">创建家族树</div>
    </div>

    <!--屏幕背景变暗的背景  -->
    <div
      class="commodity_screenBX"
      v-if="editorShow"
      catchtap="didshareNoShow"
      hover-stop-propagation="true"
      @click="editorShow = false"
    >
      <div class="chellView_bottomYH" @click="didYiHuaJiemu()">
        <img
          src="../assets/img/yihuajiemu.png"
          v-if="userDic.is_wife == 0"
          style="width: 100%; height: 100%"
        />
      </div>
      <div class="chellView_top" v-if="userDic.is_wife == 0">
        <div class="chellView" @click="didAddfather()">
          <div class="chellView_image">
            <img
              v-if="fatherDic.thumb"
              :src="fatherDic.thumb"
              style="width: 100%; height: 100%"
            />
            <img
              v-if="!fatherDic.thumb"
              src="../assets/img/icon_default_man.png"
              style="width: 100%; height: 100%"
            />
          </div>
          <div class="chellView_text" v-if="JSON.stringify(fatherDic) != '{}'">
            {{ fatherDic.username }}
          </div>
          <div class="chellView_text" v-if="JSON.stringify(fatherDic) == '{}'">
            添加父亲
          </div>
        </div>

        <div class="chellView" @click="didAddmother()">
          <div class="chellView_image">
            <img
              v-if="motherDic.thumb"
              :src="motherDic.thumb"
              style="width: 100%; height: 100%"
            />
            <img
              v-if="!motherDic.thumb"
              src="../assets/img/icon_default_woman.png"
              style="width: 100%; height: 100%"
            />
          </div>
          <div class="chellView_text" v-if="JSON.stringify(motherDic) != '{}'">
            {{ motherDic.username }}
          </div>
          <div class="chellView_text" v-if="JSON.stringify(motherDic) == '{}'">
            添加母亲
          </div>
        </div>
      </div>

      <div class="chellView_cent" v-if="userDic.is_wife == 0">
        <div class="chellView_right">
          <div
            class="chellView"
            v-if="userDic.gender == 0"
            @click="didAddwife()"
          >
            <div class="chellView_image">
              <img
                v-if="wifeDic.thumb"
                :src="wifeDic.thumb"
                style="width: 100%; height: 100%"
              />
              <img
                v-if="!wifeDic.thumb"
                src="../assets/img/icon_default_woman.png"
                style="width: 100%; height: 100%"
              />
            </div>
            <div class="chellView_text" v-if="JSON.stringify(wifeDic) != '{}'">
              {{ wifeDic.username }}
            </div>
            <div class="chellView_text" v-if="JSON.stringify(wifeDic) == '{}'">
              添加妻子
            </div>
          </div>

          <div
            class="chellView"
            v-if="userDic.gender == 1"
            @click="didAddhusband()"
          >
            <div class="chellView_image">
              <img
                v-if="wifeDic.thumb"
                :src="wifeDic.thumb"
                style="width: 100%; height: 100%"
              />
              <img
                v-if="!wifeDic.thumb"
                src="../assets/img/icon_default_man.png"
                style="width: 100%; height: 100%"
              />
            </div>
            <div class="chellView_text" v-if="JSON.stringify(wifeDic) != '{}'">
              {{ wifeDic.username }}
            </div>
            <div class="chellView_text" v-if="JSON.stringify(wifeDic) == '{}'">
              添加丈夫
            </div>
          </div>
        </div>

        <div class="commodity_attr_box" @click="didEditorUser()">
          <div class="imageView">
            <img
              v-if="userDic.thumb"
              :src="userDic.thumb"
              style="width: 100%; height: 100%"
            />
            <div v-if="!userDic.thumb">
              <img
                v-if="userDic.gender == 1"
                src="../assets/img/icon_default_woman.png"
                style="width: 100%; height: 100%"
              />
              <img
                v-if="userDic.gender != 1"
                src="../assets/img/icon_default_man.png"
                style="width: 100%; height: 100%"
              />
            </div>
          </div>

          <div class="contviewN">
            <div class="textTiten">姓名:{{ userDic.username }}</div>
          </div>

          <div class="contview">
            <div class="textTite" v-if="userDic.gender == 0">性别:男</div>
            <div class="textTite" v-if="userDic.gender == 1">性别:女</div>
            <div class="textTite" v-if="userDic.ranking">
              排行:{{ userDic.ranking }}
            </div>
            <div class="textTite" v-if="!userDic.ranking">排行:--</div>
          </div>
          <block v-if="userDic.telPhone">
            <div class="textTite">电话:{{ userDic.telPhone }}</div>
          </block>
          <block v-if="!userDic.telPhone">
            <div class="textTite" v-if="userDic.birthday">
              生日:{{ userDic.birthday }}
            </div>
            <div class="textTite" v-if="!userDic.birthday">生日:--</div>
          </block>

          <div class="textTite" v-if="userDic.address">
            现居:{{ userDic.address }}
          </div>
          <div class="textTite" v-if="!userDic.address">现居:--</div>
          <div class="combuttView">编辑信息</div>
        </div>

        <div class="chellView_right">
          <div class="chellView" @click="didAddbrother()">
            <div class="chellView_image">
              <img
                src="../assets/img/icon_default_man.png"
                style="width: 100%; height: 100%"
              />
            </div>
            <div class="chellView_text">添加兄弟</div>
          </div>

          <div class="chellView" @click="didAddsister()">
            <div class="chellView_image">
              <img
                src="../assets/img/icon_default_woman.png"
                style="width: 100%; height: 100%"
              />
            </div>
            <div class="chellView_text">添加姐妹</div>
          </div>
        </div>
      </div>

      <div class="chellView_cent1" v-if="userDic.is_wife == 1">
        <div class="commodity_attr_box" @click="didEditorUser()">
          <div class="imageView">
            <img
              v-if="wifeDic.thumb"
              :src="userDic.thumb"
              style="width: 100%; height: 100%"
            />
            <div v-if="!wifeDic.thumb">
              <img
                v-if="wifeDic.gender == 1"
                src="../assets/img/icon_default_woman.png"
                style="width: 100%; height: 100%"
              />
              <img
                v-if="wifeDic.gender != 1"
                src="../assets/img/icon_default_man.png"
                style="width: 100%; height: 100%"
              />
            </div>
          </div>

          <div class="contviewN">
            <div class="textTiten">姓名:{{ userDic.username }}</div>
          </div>
          <div class="contview">
            <div class="textTite" v-if="userDic.gender == 0">性别:男</div>
            <div class="textTite" v-if="userDic.gender == 1">性别:女</div>
            <div class="textTite" v-if="userDic.ranking">
              排行:{{ userDic.ranking }}
            </div>
            <div class="textTite" v-if="!userDic.ranking">排行:--</div>
          </div>
          <block v-if="userDic.telPhone">
            <div class="textTite">电话:{{ userDic.telPhone }}</div>
          </block>
          <block v-if="!userDic.telPhone">
            <div class="textTite" v-if="userDic.birthday">
              生日:{{ userDic.birthday }}
            </div>
            <div class="textTite" v-if="!userDic.birthday">生日:--</div>
          </block>
          <div class="textTite" v-if="userDic.address">
            现居:{{ userDic.address }}
          </div>
          <div class="textTite" v-if="!userDic.address">现居:--</div>
          <div class="combuttView">编辑信息</div>
        </div>
      </div>

      <div class="chellView_bottom">
        <div class="chellView" @click="didAddson()">
          <div class="chellView_image">
            <img
              src="../assets/img/icon_default_man.png"
              style="width: 100%; height: 100%"
            />
          </div>
          <div class="chellView_text">添加儿子</div>
        </div>

        <div class="chellView" @click="didAdddaughter()">
          <div class="chellView_image">
            <img
              src="../assets/img/icon_default_woman.png"
              style="width: 100%; height: 100%"
            />
          </div>
          <div class="chellView_text">添加女儿</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import html2canvas from "html2canvas";

// import BScroll from "better-scroll";
import TreeCharts from "./TreeCharts.vue";

import EnentVue from "./eventVue";

export default {
  name: "gohome",
  components: { TreeCharts },

  data() {
    return {
      deviceDic: null,
      is_ONE: "",
      isR: true,
      isDH: false,
      isImage: false,
      imgUrl: "",

      isAD: true,
      isiPhoneX: false,
      dataSource: "",

      width: 0,
      height: 0,

      shrenameid: "",
      tpname: "智家谱",
      region: "",
      tpassword: "",

      userDic: null,
      wifeDic: null, //妻子,丈夫
      motherDic: null,
      fatherDic: null,
      parents: null,

      mianDic: null,
      editorShow: false,

      showtree: false,
      shreShow: false,

      //切换册谱
      swchtCepu: "1",
      fanye: false,
      donghua: "",
      listNewest: [],
      xzindex: 0,
      cepuData: null,

      isLuru: false,
      isJiaPuXY: false,

      bookPreId: "",
      xuyan: "",
      yuanliu: "",
      zuxuan: "",
      zibei: "",
      houji: "",

      gerenJei: "",
      peiouJei: "",
    };
  },

  methods: {
    //获取数据
    getReaDataAll: function () {
      var that = this;
      let password = localStorage.getItem("passwodr");
      var prem = {
        pass_wode: password,
      };
      this.axios
        .post(this.COMMON.httpUrl + "go_home/readata", prem)
        .then((res) => {
          if (res.data.code == 1) {
            var familyJson = res.data.data.familyJson;
            if (familyJson) {
              var familyJsonStr = this.COMMON.decode(familyJson);
              var obj = JSON.parse(familyJsonStr);
              that.mianDic = obj;
              if (obj) {
                that.is_ONE = "1";
              } else {
                that.is_ONE = "2";
              }
            } else {
              that.is_ONE = "2";
            }
          } else if (res.data.code == 2) {
            that.$router.push({ name: "homeBook" });
          } else {
            that.is_ONE = "2";
          }
        });
    },

    //接收广播传值
    formEmit(event) {
      var nameId = event.nameid + "";
      var dic = this.getMaxFloor(nameId);
      this.userDic = event;

      this.wifeDic = dic.wifeDic;
      this.motherDic = dic.motherDic;
      this.fatherDic = dic.fatherDic;

      this.editorShow = true;
    },

    //插入数据
    getMaxFloor(nameid) {
      var treeData = this.mianDic;
      var wifeDic = {};
      var userDic = {};
      var motherDic = {};

      var fatherDic = {};
      var parents = null;
      var xinArray = new Array();
      var childArray = new Array();

      each(treeData, nameid);

      function each(data, nameid) {
        if (data.nameid == nameid) {
          if (data.wife) {
            wifeDic = data.wife;
          }
          userDic = data;
          return;
        } else if (data.wife && data.wife.nameid == nameid) {
          wifeDic = data.wife;
          userDic = data;
          return;
        } else if (data.children && data.children.length > 0) {
          for (var i = 0; i < data.children.length; i++) {
            var dic = data.children[i];
            if (dic.nameid == nameid) {
              addParents(data);
              addxinchildArray(data);

              addchildArray(dic);
              userDic = dic;
              if (dic.wife) {
                wifeDic = dic.wife;
              }
              return;
            } else if (dic.wife && dic.wife.nameid == nameid) {
              addParents(data);
              addxinchildArray(data);
              addchildArray(dic);
              userDic = dic;
              wifeDic = dic.wife;
              return;
            } else if (dic.children && dic.children.length > 0) {
              each(dic, nameid);
            }
          }
        }
      }

      function addParents(data) {
        parents = data;
        if (data.gender == 0) {
          fatherDic = data;
          if (data.wife) {
            motherDic = data.wife;
          }
        } else if (data.gender == 1) {
          motherDic = data;
          if (data.wife) {
            fatherDic = data.wife;
          }
        }
      }

      function addxinchildArray(data) {
        var newarray = data.children;

        for (var i = 0; i < newarray.length; i++) {
          var dic = newarray[i];
          if (dic.nameid != nameid) {
            xinArray.push(dic);
          }
        }
      }

      function addchildArray(data) {
        if (data.children) {
          childArray = data.children;
        }
      }

      this.parents = parents;
      var newmianDic = {
        userDic: userDic,
        wifeDic: wifeDic,
        motherDic: motherDic,
        fatherDic: fatherDic,
        childArray: childArray,
        xinArray: xinArray,
      };
      return newmianDic;
    },

    //点击移花接木
  didYiHuaJiemu: function () {
     var userDic = this.userDic;
      var dicjson = JSON.stringify(userDic);
      this.$router.push({
        name: "hm",
        params: {  dicjson: dicjson },
      });

  },

    //创建新人
    didAddNew: function () {
      this.$router.push({ name: "addFamily", params: { type: "new" } });
    },

    //添加儿子
    didAddson: function () {
      var userDicId = this.userDic.nameid;

      this.$router.push({
        name: "addFamily",
        params: { type: "son", nameid: userDicId },
      });
    },

    //添加女儿
    didAdddaughter: function () {
      var userDicId = this.userDic.nameid;
      this.$router.push({
        name: "addFamily",
        params: { type: "daughter", nameid: userDicId },
      });
    },

    //添加兄弟
    didAddbrother: function () {
      var parents = this.parents;
      if (parents) {
        var dicjson = JSON.stringify(parents);
        this.$router.push({
          name: "addFamily",
          params: { type: "brother", dicjson: dicjson },
        });
      } else {
        alert("请先添加父辈");
      }
    },
    //添加姐妹
    didAddsister: function () {
      var parents = this.parents;
      if (parents) {
        var dicjson = JSON.stringify(parents);
        this.$router.push({
          name: "addFamily",
          params: { type: "sister", dicjson: dicjson },
        });
      } else {
        alert("请先添加父辈");
      }
    },

    //编辑自己
    didEditorUser: function () {
      var userDic = this.userDic;
      userDic.children = null;
      var dicjson = JSON.stringify(userDic);
      this.$router.push({
        name: "addFamily",
        params: { type: "user", dicjson: dicjson },
      });
    },

    //编辑妻子

    didAddwife: function () {
      var userDic = this.userDic;
      userDic.children = null;
      var dicjson = JSON.stringify(userDic);
      this.$router.push({
        name: "addFamily",
        params: { type: "wife", dicjson: dicjson },
      });
    },
    //编辑丈夫
    didAddhusband: function () {
      var userDic = this.userDic;
      userDic.children = null;
      var dicjson = JSON.stringify(userDic);
      this.$router.push({
        name: "addFamily",
        params: { type: "husband", dicjson: dicjson },
      });
    },

    //添加母亲
    didAddmother: function () {
      var parents = this.parents;
      if (parents) {
        var motherDic = this.motherDic;
        if (JSON.stringify(motherDic) != "{}") {
          var dicjson = JSON.stringify(motherDic);
          this.$router.push({
            name: "addFamily",
            params: { type: "user", dicjson: dicjson },
          });
        } else {
          let dicjson = JSON.stringify(parents);
          this.$router.push({
            name: "addFamily",
            params: { type: "wife", dicjson: dicjson },
          });
        }
      } else {
        this.$router.push({ name: "addFamily", params: { type: "mother" } });
      }
    },
    //添加父亲
    didAddfather: function () {
      var parents = this.parents;
      if (parents) {
        var fatherDic = this.fatherDic;
        if (JSON.stringify(fatherDic) != "{}") {
          var dicjson = JSON.stringify(fatherDic);
          this.$router.push({
            name: "addFamily",
            params: { type: "user", dicjson: dicjson },
          });
        } else {
          let dicjson = JSON.stringify(parents);
          this.$router.push({
            name: "addFamily",
            params: { type: "husband", dicjson: dicjson },
          });
        }
      } else {
        this.$router.push({ name: "addFamily", params: { type: "father" } });
      }
    },

  },

  mounted: function () {
    ///添加点击节点的通知
    EnentVue.$on("NOTI_TREECLICK", this.formEmit);

    this.getReaDataAll();
  },
};
</script>

<style>
.hedeimage {
  width: 100%;
  height: 100%;
  position: fixed;
  background-size: 100% 100%;
  z-index: -2;
}
movable-area {
  overflow: hidden;
  width: 100vw;
}

movable-view {
  display: flex;
  justify-content: center;
  align-items: center;
}

.missing-view {
  padding-top: 50px;
  text-align: center;
  width: 100%;
}
.missing-but {
  width: 96%;
  margin-left: 2%;
  height: 45px;
  line-height: 45px;
  text-align: center;
  background-color: #0c3874;
  color: #fff;
  border-radius: 3px;
}

/*弹出框 */
.commodity_screenBX {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(1, 1, 1, 0.5);
  overflow: hidden;
  z-index: 1000;
  padding-top: 5px;
}

.commodity_screen {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(1, 1, 1, 0.5);
  overflow: hidden;
  z-index: 1000;
  padding-top: 100px;
}

.commodity_attr_box {
  width: 180px;
  margin-left: 5px;
  margin-top: 10px;
  border-radius: 10px;
  padding-bottom: 10px;
  background-color: white;
}

.imageView {
  width: 85px;
  height: 85px;
  margin: 0 auto;
  padding-top: 10px;
}
.textTite {
  margin-top: 5px;

  line-height: 20px;
  margin-left: 10%;
  font-size: 12px;
  color: #0c3874;
}

.textTiteName {
  width: 100%;
  height: 35px;
  line-height: 35px;
  text-align: center;
  color: #000;
  font-size: 16px;
}
.textTite .textB {
  border-width: 350px;
  color: #444;
  display: inline-block;
}
.contview {
  display: flex;
  flex-direction: row;
  margin-right: 8%;
  align-items: center;
  justify-content: space-between;
}

.combuttView {
  margin-top: 2px;
  width: 60%;
  margin-left: 20%;
  height: 25px;
  line-height: 25px;
  text-align: center;

  color: #0c3874;
  font-size: 13px;
}
.liftbutt {
  width: 25px;
  height: 25px;
  padding-top: 20px;
  margin: 0 auto;
}
.contviewN {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.textTiten {
  margin-top: 5px;
  line-height: 20px;
  margin-left: 10%;
  font-size: 13px;
  color: #0c3874;
}
.text-butt {
  width: 150px;
  height: 20px;
  margin-right: 5%;
  color: #fff;
  background-color: #32cd32;
  font-size: 10px;
  text-align: center;
  line-height: 20px;
  border-radius: 10px;
}
.textbutt {
  margin-right: 5%;
  width: 25px;
  height: 10px;

  background-image: url(data:image/png;base64,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);
}
.textbutt button {
  opacity: 0;
}
button::after {
  border: none;
  min-height: 10px;
  min-width: 25px;
  margin-left: 0;
  margin-right: 0;
}
/* 添加 */

.chellView_bottom {
  width: 140px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.chellView_top {
  width: 140px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.chellView_cent {
  width: 310px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.chellView_cent1 {
  margin-top: 50px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.chellView {
  margin-top: 10px;
  width: 60px;
  height: 75px;
  background-color: #fff;
  border-radius: 3px;
}
.chellView_image {
  margin: 0 auto;
  margin-top: 5px;
  width: 45px;
  height: 45px;
}
.chellView_text {
  width: 100%;
  text-align: center;
  line-height: 25px;
  font-size: 10px;
}
.chellView {
  padding-top: 5px;
}
.chellView_right {
  margin-left: 5px;
  padding-top: 5px;
}

.chellView_bottomYH {
  width: 150px;
  height: 85px;
  margin: 0 auto;
  border-radius: 3px;
  text-align: center;
}

/*分享弹出框 */

.commodity_attr_boxshre {
  width: 80%;
  margin: 0 auto;
  margin-top: 50px;
  background: #fff;
  border-radius: 10px;
}
.imageViewshre {
  width: 100%;
  height: 100px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: #0d5dcce0;
}
.shretx {
  padding-top: 8px;
  margin-left: 10px;
  color: #fff;
  font-size: 13px;
}
.shrePa {
  width: 100%;
  text-align: center;
  height: 75px;
  line-height: 75px;
  font-size: 50px;
  color: #fff;
  letter-spacing: 10px;
  font-weight: 1000;
}
.textTiteshre {
  margin-top: 15px;
  width: 80%;
  line-height: 30px;
  margin-left: 10%;
  text-align: center;
  font-size: 13px;
  color: #777;
  white-space: pre-wrap;
  display: inline-block;
}
.textTiteshre .textB {
  border-width: 350px;
  color: #444;
  display: inline-block;
}

.combuttViewshre {
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #f3f3f3;
}
.liftbuttshre {
  width: 50%;
  text-align: center;
  color: #999;
  font-size: 15px;
  height: 40px;
  line-height: 40px;
}
.combuttViewshre .btn-share {
  width: 50%;
  text-align: center;
  color: #999;
  font-size: 15px;
  height: 40px;
  background-color: rgba(1, 1, 1, 0);
  color: #227df8;
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: #f3f3f3;
  border-radius: 0;
  border-bottom-right-radius: 10px;
}
.btn-share::after {
  border: none;
}

/* 序言按钮 */
.contMianTextView {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.contMianTXuYanText {
  height: 25px;
  line-height: 25px;
  text-align: center;
  color: #444444;
  letter-spacing: 3px;
  font-size: 7px;
  font-weight: 700;
  font-family: "SimSuncss";
}
.contMianTexL {
  width: 50x;
  height: 50px;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.contMianTextButt {
  width: 40px;
  margin-right: 5px;
  height: 20px;
  line-height: 20px;
  background-color: #0c3874;
  text-align: center;
  color: white;
  font-size: 5px;
  border-radius: 3px;
}
.contMianluru {
  width: 13px;
  height: 13px;
}
.contMiandetailText {
  margin-left: 3%;
  width: 94%;
  margin-top: 1px;
  height: 200px;
  font-size: 6px;
  line-height: 10px;
}

/**新加越苏 */
#main {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#content {
  float: left;
  padding: 40px;
}

.wrapper {
  position: absolute;
  top: 45px;
  overflow: hidden;
  z-index: 1;
}
.content {
  width: 100%;
}
</style>
